module.exports = __webpack_public_path__ + "img/towd_2.2024f9a9.jpg";